import type { UseFetchOptions } from 'nuxt/app'
import { dynamicContentTransformer } from '~/utils/dynamicContentTransformer'

export function useStrapiSingleType<T, R = T>(
  url: string,
  options: UseFetchOptions<T, R> = {}
) {
  const config = useRuntimeConfig()
  const preview = useRoute().query.preview === 'true'
  const { strapiApiBaseURL, strapiDraftBaseURL, strapiApiKey } = config.public
  const baseURL = preview ? strapiDraftBaseURL : strapiApiBaseURL
  const staticMetrics = useStaticMetrics()
  const finalUrl = new URL(baseURL + url.replace(/^\/?(api\/)?/, ''))

  if (preview) {
    finalUrl.searchParams.set('status', 'draft')
  }

  let key = finalUrl.pathname + finalUrl.search
  if (key[0] === '/') {
    // remove the leading slash so that google does not crawl unwanted urls
    key = key.slice(1)
  }

  const defaults: UseFetchOptions<T, R> = {
    baseURL: finalUrl.origin,
    // cache request
    key,

    headers: {
      Authorization: `Bearer ${strapiApiKey}`,
    },
  }

  const baseTransform = (data: T): R | T => {
    if (options.transform)
      return dynamicContentTransformer<R>(
        options.transform!(data) as R,
        staticMetrics
      )
    return dynamicContentTransformer<T>(data, staticMetrics) as T
  }

  const params = { ...defaults, ...options, transform: baseTransform }

  return useFetch(finalUrl.href, params)
}
